import { Pipe, PipeTransform } from '@angular/core';

type TimeAgoOptions = {
  now?: number; // útil para testes
  maxUnit?: 'year' | 'month' | 'week' | 'day' | 'hour' | 'minute' | 'second';
};

@Pipe({
  name: 'timeAgo',
  pure: true,
})
export class TimeAgoPipe implements PipeTransform {
  private rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

  transform(timestamp: number | string | Date | null | undefined, opts?: TimeAgoOptions): string {
    if (timestamp === null || timestamp === undefined) return '';

    const nowMs = opts?.now ?? Date.now();
    const dateMs = this.toMs(timestamp);

    if (Number.isNaN(dateMs)) return '';

    const diffMs = dateMs - nowMs; // futuro => positivo | passado => negativo
    const absSec = Math.abs(diffMs) / 1000;

    // "agora" para diferenças muito pequenas
    if (absSec < 5) return 'agora';

    // Define unidades em ordem (da maior pra menor)
    const units: Array<{ unit: Intl.RelativeTimeFormatUnit; seconds: number }> = [
      { unit: 'year', seconds: 60 * 60 * 24 * 365 },
      { unit: 'month', seconds: 60 * 60 * 24 * 30 },
      { unit: 'week', seconds: 60 * 60 * 24 * 7 },
      { unit: 'day', seconds: 60 * 60 * 24 },
      { unit: 'hour', seconds: 60 * 60 },
      { unit: 'minute', seconds: 60 },
      { unit: 'second', seconds: 1 },
    ];

    const maxUnit = opts?.maxUnit;
    const limitedUnits = maxUnit
      ? units.slice(0, units.findIndex((u) => u.unit === maxUnit) + 1)
      : units;

    const found = limitedUnits.find((u) => absSec >= u.seconds) ?? { unit: 'second', seconds: 1 };
    const value = Math.round(diffMs / (found.seconds * 1000)); // negativo => "há", positivo => "em"

    return this.rtf.format(value, found.unit);
  }

  private toMs(input: number | string | Date): number {
    if (input instanceof Date) return input.getTime();

    const n = typeof input === 'string' ? Number(input) : input;
    if (typeof n === 'number' && !Number.isNaN(n)) {
      // heurística: < 1e12 é segundos, senão ms
      return Math.abs(n) < 1e12 ? n * 1000 : n;
    }

    // tenta parse de string de data ISO etc.
    const parsed = new Date(String(input)).getTime();
    return parsed;
  }
}
